
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "Form2",
})
export default class extends Vue {}
